import React from "react";


import { Col, Row, Form } from "react-bootstrap";


import "./index.scss";
import InputMessageComponent from "@Components/Forms/Inputs/@Messages";
import {InputComponentStatusType} from "@Components/Forms/Inputs/Input/types";


type InputComponentProps = {
    value: string;
    setValue: (e: React.ChangeEvent<HTMLInputElement>) => void;
    type?: "text" | "email" | "number" | "password" | "password_confirmation" | "phone";
    name?: string;
    label?: string; placeholder?: string; legend?: string;
    status?: InputComponentStatusType | null;
    required?: boolean; disabled?: boolean;
    cssClasses?: string[];
    as?: 'input' | 'textarea';
    xs?: number; sm?: number; lg?: number; xl?: number;
};


export const InputComponent:React.FC<InputComponentProps> = ({
    value, setValue,
    type = "text", name,
    label, placeholder, legend,
    status = null,
    cssClasses = [],
    required = false, disabled = false,
    as = 'input',
    xs = 12, sm, lg, xl,
}) => {

    cssClasses = [
        'form-input-component',
        `${type}-input-component`,
        ...cssClasses,
    ];

    const inputCssClasses = ['form-input-component__element-field__input'];

    if (value.length > 0) {
        inputCssClasses.push('element-filled');
    }

    if (status) {
        inputCssClasses.push(`element-${status.type}`);
    }

    return (
        <Col
            xs={xs} sm={sm ?? xs} lg={lg ?? sm ?? xs} xl={xl ?? lg ?? sm ?? xs}
            className={cssClasses.join(' ')}
        >
            <Row className={'form-input-component__container'}>

                {label &&
                <Col xs={12} className={'form-input-component__element-label'}>
                    <span>{label}</span>
                    {required && <span className={'form-input-component__element-label__required-status'}>*</span>}
                </Col>
                }

                <Col xs={12} className={'form-input-component__element-field'}>
                    <Form.Control
                        as={as}
                        value={value}
                        onChange={setValue}
                        name={name}
                        type={type}
                        className={inputCssClasses.join(' ')}
                        placeholder={placeholder}
                        required={required} disabled={disabled}
                    />
                </Col>

                {status?.type &&
                <InputMessageComponent
                    type={status.type}
                    message={status?.message}
                />
                }

                {legend &&
                <Col xs={12} className={'form-input-component__element-legend'}>
                    <span>{legend}</span>
                </Col>
                }

            </Row>
        </Col>
    );

};


export default InputComponent;
